import React, { ReactNode, useContext, useEffect, useState } from 'react';

import RegionDetailsContext from '@totem/components/portfolio/regions/details/RegionDetailsContext';
import { RegionSummaryItem } from '@totem/components/portfolio/regions/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { Params } from '@totem/types/common';
import { V2_REGIONS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const RegionDetailsContainer = ({ id, children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);

  const [loading, setLoading] = useState<boolean>(true);
  const [region, setRegion] = useState<RegionSummaryItem>(null);

  useEffect(() => {
    setLoading(true);

    const payload: Params = {
      paging: { page: 0, pageSize: 0 },
      sort: { field: 'name', direction: 1 },
      filters: [{ field: '_id', values: [id] }],
    };

    fetch(V2_REGIONS_ENDPOINT, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result: RegionSummaryItem[]) => {
        setRegion(
          Array.isArray(result) && result.length > 0 ? result[0] : null,
        );
      })
      .then(() => {
        setLoading(false);
      });
  }, [id, userProfile.organization.id, getApiToken]);

  return (
    <RegionDetailsContext.Provider value={{ id, loading, region }}>
      {children}
    </RegionDetailsContext.Provider>
  );
};

export default RegionDetailsContainer;
